module.exports = __webpack_public_path__ + "img/complete.128a6aa4.png";